<script setup>
  import { useDisplay } from 'vuetify'
  import { useRoute } from 'vue-router'
  import { computed } from 'vue'

  const { mobile } = useDisplay();
  const route = useRoute();

  const queries = computed(()=> new URLSearchParams(route.query).toString())
</script>

<template>
<v-app>
  <v-app-bar  elevation="0" class="border-b" :height="mobile ? 78 : 104 ">
   <v-container class="d-flex flex-row align-center">
      <div class="d-flex flex-column ga-1">
        <img src="@/assets/images/logo/classinoLogo.svg" alt="لوگو کلاسینو - Classino logo" :width="mobile ? 103 : 121" :height="mobile ? 24 : 38">
        <span class="text-caption font-weight-bold" style="font-family: IranSans!important;">آموزشگاه آنلاین ابتدایی تا کنکور</span>
      </div>
     <v-spacer></v-spacer>
     <v-btn :href="`https://app.classino.com/redirectAfterLogin/store/course=538,541,544&${queries || ''}`" target="_blank" variant="elevated" flat color="primary" rounded="lg" style="font-family: IranSans !important;" class="text-decoration-none">
ثبت نام دوره
     </v-btn>
   </v-container>
  </v-app-bar>

  <v-main>
    <router-view v-slot="{ Component, route }">
      <v-slide-x-transition hide-on-leave>
        <component :is="Component" :key="route.path"  />
      </v-slide-x-transition>
    </router-view>
  </v-main>
</v-app>
</template>

<style scoped lang="scss">
  * {
    font-family: IranSans;
  }
</style>